import React from "react";
import FancyThanks from "@/components/FancyThanks";

/**
 * v1.25.52 — Full-screen "WELCOME" celebration for onboarding moments
 * (new party added, new company onboarded). Shares the shards+3D-text
 * primitive with ThanksOverlay so onboarding feels as premium as verify.
 */
export default function WelcomeOverlay({ open, onClose, title = "WELCOME", subtitle = "" }) {
    return (
        <FancyThanks
            open={open}
            onClose={onClose}
            title={(title || "WELCOME").toUpperCase()}
            subtitle={subtitle}
            caption=""
            ctaLabel="Let's go"
            palette="indigo"
            testId="welcome-overlay"
        />
    );
}
